import {
  SET_ERROR,
  SET_SUCCESS,
  SET_FETCHING,
  SET_CLOSE,
  SET_CLEAR,
  RESET_REQUEST,
} from "./actionsTypes";

export const setFetching = ({ isFetching }) => ({
  type: SET_FETCHING,
  payload: { isFetching },
});
export const setError = ({ message, type, isOpen, statusCode = 0 }) => ({
  type: SET_ERROR,
  payload: { message, type, isOpen, statusCode },
});
export const setSuccess = ({ message, type, isOpen }) => ({
  type: SET_SUCCESS,
  payload: { message, type, isOpen },
});
export const setClose = () => ({ type: SET_CLOSE });
export const setClear = () => ({ type: SET_CLEAR });
export const resetRequest = () => ({ type: RESET_REQUEST });
